"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiquidityPeriodEnum = void 0;
var LiquidityPeriodEnum;
(function (LiquidityPeriodEnum) {
    LiquidityPeriodEnum[LiquidityPeriodEnum["MONTHLY"] = 1] = "MONTHLY";
    LiquidityPeriodEnum[LiquidityPeriodEnum["QUARTERLY"] = 2] = "QUARTERLY";
    LiquidityPeriodEnum[LiquidityPeriodEnum["YEARLY"] = 3] = "YEARLY";
})(LiquidityPeriodEnum || (exports.LiquidityPeriodEnum = LiquidityPeriodEnum = {}));
